<script>
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  name: 'rex-rounded-autocomplete',
  components: {
    VueAutosuggest
  },
  props: {
    label: {
      type: String,
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    endpoint: {
      type: String,
      default: () => null,
      required: true
    },
    params: {
      type: Object,
      default: () => null,
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => null,
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    name: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    timer: null,
    query: null,
    config: {},
    inFocus: false,
  }),
  inject: ['$validator'],
  computed: {
    collection() {
      return this.$store.getters['autocomplete/getCollection']
    },
    isLoading() {
      return this.$store.getters['autocomplete/isLoading']
    },
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value,
        })

        this.$emit('onChange', {
          event: value,
          element: this.$vnode.elm
        })
      }
    },
    error() {
      if (this.validate) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
          .find(error => error.field === this.name)

        return err ? err.message : null
      }

      return null
    }
  },
  watch: {
    'collection'() {
      this.collection.forEach((item, index) => {
        this.config[item.name] = {
          label: item.label,
          onSelected: (selected) => {
            this.value = {
              ...selected.item
            }

            this.clearAutocompleteData()
          }
        }
      })
    },
  },
  created() {
    this.config = {
      default: {
        label: '',
        onSelected: (selected) => {
          this.clearAutocompleteData()
        }
      }
    }
  },
  methods: {
    typingHandler(term) {
      if (term.length >= 2) {
        clearTimeout(this.timer)

        this.timer = setTimeout(() => {
          this.$store.dispatch('autocomplete/getCollection', {
            payload: {
              ...this.params,
              term,
            },
            endpoint: this.endpoint
          })
        }, 500)
      } else if (!term.length) {
        this.clearAutocompleteData()
        this.value = {
          badge: null,
          code: null,
          slug: null,
          name: null
        }
      }
    },
    handleFocusEvent() {
      this.clearAutocompleteData()
      this.inFocus = true
    },
    clearAutocompleteData() {
      this.$store.commit('autocomplete/setCollection', [])
    },
  }
}
</script>

<template>
  <div
    class="rex-rounded-field rex-rounded-field-autocomplete"
    :class="[
      cssClass,
      {
        disabled: disabled
      }
    ]"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field__label"
    >
      {{ label }}
    </h3>
    <div
      class="autosuggest-container"
      :class="{
        'autosuggest-container--loading': isLoading && inFocus
      }"
    >
      <b-field
        :type="{'is-danger': errors.has(name) || error}"
        :message="errors.first(name) || error"
      >
        <vue-autosuggest
          v-model="value.name"
          v-validate="validate"
          :name="name"
          :suggestions="collection"
          :input-props="{
            placeholder: placeholder,
            disabled: disabled
          }"
          :section-configs="config"
          @input="typingHandler"
          @focus="handleFocusEvent"
          @blur="inFocus = false"
        >
          <div
            v-if="collection"
            slot-scope="{suggestion}"
          >
            <template slot="before-section-default">
              {{ suggestion.name }}
            </template>
            <div class="rex-rounded-field-autocomplete__item">
              <span class="rex-rounded-field-autocomplete__item-name">
                {{ suggestion.item.name }}
              </span>
              <span class="rex-rounded-field-autocomplete__item-badge">
                {{ suggestion.item.badge }}
              </span>
            </div>
          </div>
        </vue-autosuggest>
      </b-field>
    </div>
  </div>
</template>
